import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Button, Icon, Result, WingBlank } from 'antd-mobile'
import { FormattedMessage, useIntl } from 'react-intl'
import { getParameterByName } from '../../components/common/utils'

import './result.css'

export default function Success() {
  const { formatMessage } = useIntl()
  const { push } = useHistory()
  const location = useLocation()

  const { email, mobile, countryCode } = location?.state?.profile
  const referer = getParameterByName('referer') || ''
  return (
    <div className="result">
      <Result
        img={<Icon type="check-circle" className="spe" style={{ fill: '#1F90E6' }} />}
        title={formatMessage({ id: 'success-title' })}
        message={
          <div className="result-detail">
            <div className="success">
              <WingBlank size="lg">
                <div className="success-has-sso">
                  <p>
                    <FormattedMessage id="success-hasSso" />
                    <br />
                    <strong>{email}</strong>
                    <br />
                    <br />
                  </p>
                </div>
              </WingBlank>
            </div>
            <WingBlank size="lg">
              <Button
                icon="right"
                type="primary"
                onClick={() => push(referer ? `/emailLogin?referer=${referer}` : '/emailLogin')}
              >
                <FormattedMessage id="success-login" />
              </Button>
            </WingBlank>
          </div>
        }
      />
    </div>
  )
}
